<app-header></app-header>

<div class="main-content">
    <ng-content select="router-outlet"></ng-content>
</div>

<app-footer></app-footer>
<div id="menu-box-sideBar" [class.menuActive]="bottomBarActive" *ngIf="auth.IsAuthUser() ">
    <app-bottom-nav-bar></app-bottom-nav-bar>
</div>